module.exports = __webpack_public_path__ + "img/results1.076d9160.jpg";